module.exports = __webpack_public_path__ + "static/media/logo.6667d37d.png";